import React, { useState } from 'react';
import { useGlobalContext } from "../../GlobalContext";
import generateHarianAngsuran2PDF from './pdf/HarianAngsuran2';

const HarianAngsuran2 = () => {
  const { api } = useGlobalContext();
  const hariini = new Date().toISOString().split('T')[0];
  const [startDate, setStartDate] = useState(hariini);
  const [endDate, setEndDate] = useState(hariini);
  const [isLoading, setIsLoading] = useState(false);
  const [isExporting, setIsExporting] = useState(false);
  const [jenisPiutang, setJenisPiutang] = useState("D");

  const handleStartDateChange = (e) => setStartDate(e.target.value);
  const handleEndDateChange = (e) => setEndDate(e.target.value);

  const printToPDF = async () => {
    const data = await fetchData();
    if (!data || data.length === 0) {
      alert("Tidak ada laporan untuk dicetak.");
      return;
    }
    generateHarianAngsuran2PDF(data, startDate, endDate);
  };

  const fetchData = async () => {
    if (!startDate || !endDate) {
      alert("Silakan pilih tanggal mulai dan akhir.");
      return [];
    }

    setIsLoading(true);
    try {
      const res = await api.get(`/api/laporan/angsuran2/${startDate}/${endDate}/${jenisPiutang}`);
      console.log("[Laporan Angsuran2] request:", `/api/laporan/angsuran2/${startDate}/${endDate}/${jenisPiutang}`);
      console.log("[Laporan Angsuran2] response:", res);
      return res?.data?.data || res?.data || [];
    } catch (error) {
      console.error("Gagal mengambil data laporan angsuran2:", error);
      if (error.response) {
        alert(`Gagal mengambil data: ${error.response.status} - ${error.response.data?.message || 'Terjadi kesalahan pada server.'}`);
      } else if (error.request) {
        alert("Tidak ada respons dari server. Pastikan backend berjalan.");
      } else {
        alert(`Kesalahan: ${error.message}`);
      }
      return [];
    } finally {
      setIsLoading(false);
    }
  };

  const handleExportExcel = async (e) => {
    e.preventDefault();
    if (!startDate || !endDate) {
      alert("Silakan pilih tanggal mulai dan akhir.");
      return;
    }
    setIsExporting(true);    

    try {
      const resp = await api.get(`/api/laporan/angsuran2/excel/${startDate}/${endDate}/${jenisPiutang}`, {
        responseType: "blob",
      });

      const blob = new Blob([resp.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Laporan_Angsuran2_${jenisPiutang}_${startDate}_sampai_${endDate}.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      alert("Excel berhasil diunduh!");
    } catch (error) {
      console.error("Export Excel error:", error);
      if (error.response) {
        const status = error.response.status;
        const message = error.response.data?.message || error.response.data || error.message;
        if (status === 401) {
          alert("Otentikasi gagal. Silakan login ulang.");
        } else if (status === 404) {
          alert("Tidak ada laporan untuk dicetak.");
        } else {
          alert(`Gagal mengekspor Excel: ${message}`);
        }
      } else if (error.request) {
        alert("Tidak ada respons dari server. Pastikan backend berjalan.");
      } else {
        alert(`Kesalahan: ${error.message}`);
      }
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <div className="container mt-3">
      <div className="row justify-content-center">
        <div className="col-12 col-md-8 col-lg-6">
          <div className="card card-info">
            <div className="card-header bg-info text-white">
              <h5 className="card-title">Laporan Harian Angsuran 2</h5>
            </div>
            <form className="form-horizontal">
              <div className="card-body">
                <div className="form-group row d-flex align-items-center mb-1">
                  <label className="col-md-3 col-sm-3 col-form-label">Tanggal</label>
                  <div className="col-md-4 col-sm-4">
                    <input type="date" className="form-control" value={startDate} onChange={handleStartDateChange} />
                  </div>
                  <div className="col-auto">s/d</div>
                  <div className="col-sm-4">
                    <input type="date" className="form-control" value={endDate} onChange={handleEndDateChange} />
                  </div>
                </div>
                <div className='form-group row mb-1 mt-3'>
                  <label className="col-md-3 col-form-label">Jenis Pinjaman</label>
                  <div className="col-md-5">
                    <select
                      name="jenis_pinjaman"
                      className="form-control"
                      value={jenisPiutang}
                      onChange={e => setJenisPiutang(e.target.value)}
                    >
                      <option value="D">Angsuran D</option>
                      <option value="C">Angsuran C</option>                    
                    </select>
                  </div>
                </div>
              </div>
              <div className="card-footer text-right">
                <button
                  type="button"
                  className="btn btn-primary btn-sm"
                  onClick={printToPDF}
                  disabled={isLoading || isExporting}
                >
                  {isLoading ? 'Memuat Data...' : 'Cetak Laporan'}
                </button>
                <button
                  type="button"
                  className="btn btn-success btn-sm"
                  onClick={handleExportExcel}
                  disabled={isLoading || isExporting}
                  style={{ marginLeft: 8 }}
                >
                  {isExporting ? 'Mengekspor...' : 'Export Excel'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HarianAngsuran2;
